export function escapeRegExp(string: string) {
  return string.replace(/[[\](){},.+?^$|]/g, '\\$&');
}

export function createSearchPattern(searchTerm: string) {
  return escapeRegExp(searchTerm).replace(/\*/g, '.*');
}

export function parseSearchTerms(searchString: string) {
  const orGroups = searchString.split(/\s+OR\s+/i).map((orTerm) => {
    const hasExplicitAnd = /\s+AND\s+/i.test(orTerm);

    const terms = hasExplicitAnd
      ? orTerm.split(/\s+AND\s+/i)
      : orTerm.split(/\s+/);

    return {
      terms: terms.map((term) => term.trim()).filter(Boolean),
      operator: 'AND' as const,
    };
  });

  return orGroups;
}

export function matchesFields<T>(
  item: T,
  pattern: RegExp,
  fields: (keyof T)[],
): boolean {
  return fields.some((field) => {
    const val = item[field];
    return typeof val === 'string' ? pattern.test(val.toLowerCase()) : false;
  });
}
